import css from 'styled-jsx/css';
import { colors } from '../../../config/styles';

const spinnerVisualStyle = css`
  .spinner {
    animation: rotate 3s linear infinite forwards;
    display: inline-block;
    height: 100%;
    margin: auto;
    width: 100%;
    z-index: 1;
  }

  .spinner.medium {
    max-height: 50px;
  }

  .spinner.small {
    height: 18px;
    max-width: 18px;
  }

  .spinner .spinner__svg {
    display: block;
    height: 100%;
    width: 100%;
    max-height: 50px;
  }

  .spinner .spinner__svg .spinner-ie {
    stroke-dasharray: 85;
    stroke-dashoffset: 138;
    animation: collapse 5s linear infinite forwards;
  }

  .spinner .primary .spinner__svg .path_circle {
    stroke: ${colors.white.shade1};
  }

  .spinner .primary .spinner__svg .spinner-ie {
    stroke: ${colors.white.shade1};
  }

  .spinner .secondary .spinner__svg .spinner-ie {
    stroke: var(--secondary-color);
  }

  @keyframes rotate {
    to {
      transform: rotate(1turn);
    }
  }

  @keyframes collapse {
    to {
      stroke-dashoffset: -138;
    }
  }
`;

export { spinnerVisualStyle };
